import { render, staticRenderFns } from "./systemOtherSet.vue?vue&type=template&id=19cdccc5&scoped=true&"
import script from "./systemOtherSet.vue?vue&type=script&lang=js&"
export * from "./systemOtherSet.vue?vue&type=script&lang=js&"
import style0 from "./systemOtherSet.vue?vue&type=style&index=0&id=19cdccc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdccc5",
  null
  
)

export default component.exports